<template>
    <div class="row basemap-ogc">
        <div class="col-12">
            <div class="row">
                <div class="col-12" v-if="!readonlyFormItem">
                    <TableData
                        :showTitleData="false"
                        baseClass="mb-0"
                        tableWrapperClass="py-2 px-1"
                        :startLoad="startLoadResources"
                        :route="basemapUrl"
                        :settings="table.settings"
                        :columns="table.columns()"
                        :inlineFilters="table.filters"
                        :autoUpdateFilter="table.autoUpdateFilter"
                        :externalFilters="tblFilters"
                        :autoUpdateExternalFilter="table.autoUpdateExternalFilter"
                        :addParamsToUrl="table.addParamsToUrl"
                        :loadingMsg="table.loadingMsg"
                        :notFoundMsg="table.notFoundMsg"
                        :orderByTemplate="table.orderByTemplate"
                    >
                        <template v-slot:filters="{ tableFilters, search }">
                            <form autocomplete="false" @submit.prevent="search" @keyup.enter="search">
                                <div class="row header">
                                    <div class="col-12">
                                        <HeaderList
                                            :title="null"
                                            :placeholderSearch="$t(`${translatedId}.list.placeholder_search`)"
                                            v-model="tableFilters.q"
                                            headerClass="mb-3">
                                        </HeaderList>
                                    </div>
                                </div>
                            </form>
                        </template>

                        <template v-slot:body="{row, columns, index}">
                            <td class="px-0" :class="columns[0].class" v-if="!eligibleForCrossResource(row.service) || (enableVectorLayer && eligibleForCrossResource(row.service))">
                                <ResourceItemList
                                    :value="row"
                                    :enableCrossResource="enableCrossresources"
                                    :readonlyForm="readonlyFormItem"
                                    @addResource="addResource(row, index, onSelectedItem)"
                                />
                            </td>
                        </template>
                    </TableData>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ElementMixin from "../mixins/ElementMixin";
    import ResourcesMixin from '@/app/shared/mixins/BaseResourcesGestaoMixin';

    export default {
        mixins: [
            ElementMixin,
            ResourcesMixin,
        ],
        components:{
            TableData: () => import(/* webpackChunkName: "table-data" */ '@/app/shared/components/tables/DataTable'),
            HeaderList: () => import(/* webpackChunkName: "header-list" */ '@/app/shared/components/manage/ManageHeaderList'),
            ResourceItemList: () => import(/* webpackChunkName: "ogc-resourceitemlist" */ '@/app/shared/components/ogc/resource/ResourceItemList'),
        },
        inject: {
            parentValidator: 'parentValidator',
        },
        props: {
            panelID: {
                type: String,
                default: 'default_layers',
            },
            value: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        resources: [],
                    }
                },
            },
            readonlyFormItem: {
                type: Boolean,
                default: true,
            },
            keyChilds: {
                type: String,
                default: 'childs',
            },
            keyGroup: {
                type: String,
                default: 'group_id',
            },
            basemapUrl: {
                type: String,
                default: null,
            },
            basemapItems: {
                type: Array,
                default: () => {
                    return []
                },
            },
            enableVectorLayer: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                pageID: this.panelID,
                form: this.value,
                items: this.galleryItems,
                startLoadResources: true,
                enableCrossresources: false,
                dragCrossResources: false,
                table: {
                    autoUpdateExternalFilter: false,
                    addParamsToUrl: false,
                    autoUpdateFilter: true,
                    autoUpdateExternalFilter: false,
                    settings: {},
                    filters: {
                        q: '',
                    },
                    columns: () => [
                        {
                            label: this.help.resources.list.model.name,
                            field:  'name',
                            class: '',
                            sortable: true,
                        },
                    ],
                },
            }
        },
        created() {
            this.$validator = this.parentValidator;
        },
        computed: {
            translatedId() {
                return `${this.pageID}.basemap.ogc`;
            },
            resource() {
                return this.form.resources.length ? this.form.resources[0] : null;
            },
        },
        methods: {
            onSelectedItem: function(id, idx) {
                let item = null;
                if(this.resource) {
                    item = JSON.parse(JSON.stringify(this.resource));
                }
                this.$emit('selected', {id, item});
            }
        },
    }
</script>

<style lang="scss">
</style>